import { MdEmail } from "react-icons/md";
import { FaPhoneAlt } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";

const contact =[
    {
        title: "Email  rypheaktra120624@gmail.com",
        icon:<MdEmail />,
    },
    {
        title: "Phone  093965667",
        icon:<FaPhoneAlt />,
    },
    {
        title: "Address  PhnomPenh",
        icon: <FaLocationDot />,
    }
]
export {contact}